import { render, staticRenderFns } from "./SettingsWindowItem.vue?vue&type=template&id=29e7eeda"
import script from "./SettingsWindowItem.vue?vue&type=script&lang=ts"
export * from "./SettingsWindowItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports